module.exports = __webpack_public_path__ + "static/media/Fir St, South San Francisco, CA3.b9edea70.jpg";